import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DateInput, NumberInput } from "components/table/carousel/inputs"
import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { checkDateSet } from "data/lib/dates"

import { FormError_s } from "styles/form-styles"
import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const CreditLossDetailed = (props: {rowData: [], field: string, namedItems: {}, persist: Function}) => {
  const initialItems = _.get(props, `rowData.${props.field}.items`);

  const emptyRecord = {
    percent: null,
    date: null
  }

  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }}), "date") : [{...emptyRecord, i: 0}]);
  const [homogenous, setHomogenous] = useState<boolean>(true);

  function updateVal(val:any, field:any[]):void {
    if(items[field[0]][field[1]] === val) return
    items[field[0]][field[1]] = val
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest), "date");
    let dateMode = _.get(props, `rowData.${props.field}.dateMode`);
    if (field[1] === 'date'){
      let dateModeCheck = checkDateSet(val, strippedItems)
      setHomogenous(dateModeCheck.homogenous);
      dateMode = dateModeCheck.dateMode;
    }
    props.persist({'items': strippedItems, 'state': "detailed", 'dateMode': dateMode}, 'creditlossdetail', props.rowData);
  }

  function updateItems(items:Item_t[]):void {
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest), "date");

    props.persist({'items': strippedItems, 'state': "detailed", 'dateMode': _.get(props.rowData[props.field], "dateMode")}, 'creditlossdetail', props.rowData);
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if (_.get(props, `rowData.${props.field}.state`) !== 'detailed'){
      setItems([{...emptyRecord, i: 0}]);
    }
  }, [props['rowData']])

  const item_attrs = (field) => field_attrs('multifamily', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      <NoneStateTrashIcon />
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div>
              { i === 0 && <label>Date</label> }
              <DateInput className="automated" attrs={item_attrs} field={[`${row['i']}`, 'date']} {...params} allowRelative withoutDays />
            </div>
            <div>
              { i === 0 && <label>Percent</label> }
              <NumberInput className="automated" attrs={item_attrs} field={[`${row['i']}`, 'percent']} {...params} readPrecision={2} writePrecision={2} />
            </div>
            <RowAddRemove emptyRecord={emptyRecord} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
      {!homogenous && <FormError_s>All dates must be either relative or absolute</FormError_s>}
    </div>
  )
}

export default CreditLossDetailed
